export class WorksheetLabelLink {
    id: string;
    worksheetId: string;
    worksheetLabelId: string;

    constructor(init?: Partial<WorksheetLabelLink>) {
        Object.assign(this, init);
    }
}
